import React from 'react';
import logo from './logo.svg';
import './App.css';

import queryString from 'query-string';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Draggable, {DraggableCore} from 'react-draggable'; // Both at the same time
import PieChart from 'react-minimal-pie-chart';
import Helmet from 'react-helmet';
import UISwitch from "react-switch";
import { tsThisType } from '@babel/types';

let imgSize = 150
let circleSize = imgSize/3

let titleBarSize = 60;


let imgOrigWidth = 922 //TODO::getDynamic
let imgOrigHeight = 1074

let imgDisplayWidth = imgSize
let imgDisplayHeight = imgDisplayWidth * imgOrigHeight / imgOrigWidth

let imgGridX = imgDisplayWidth
let imgGridY = imgDisplayHeight * 3/4

let totalOffsetX = imgGridX*1.4
let totalOffsetY = 20

let resources = ["wood","brick","sheep","wheat","ore","desert"]

let tileOrder = [          [1,0],[2,0],[3,0], 
                        [0,1],[1,1],[2,1],[3,1], 
                     [0,2],[1,2],[2,2],[3,2],[4,2],
                        [0,3],[1,3],[2,3],[3,3], 
                           [1,4],[2,4],[3,4]
                ]

let cityResourcesNeeded = {
  'wheat': 2,
  'ore': 3
}

let roadResourcesNeeded = {
  'wood': 1,
  'brick': 1
}

let settlementResourcesNeeded = {
  'brick': 1,
  'wood': 1,
  'wheat': 1,
  'sheep': 1
}

let totalResroucesNeeded = {
  'wood':3, 'brick':3, 'wheat':4 ,'sheep':2 , 'ore':4
}  
let totalResources = {
  'wood':0, 'brick':0, 'wheat':0 ,'sheep':0 , 'ore':0
}
let totalResourcesAll = 0

let resClrs = {
  'wood': '#139e01', 'brick': '#d86f19', 'wheat': '#fded11' ,'sheep': '#81e973' , 'ore': '#a8a8a8'
}

let boardTiles = ['brick','brick','brick', 'ore','ore','ore'  ,'wood' ,'wood' ,'wood' ,'wood',  'wheat', 'wheat', 'wheat', 'wheat', 'sheep', 'sheep', 'sheep', 'sheep', 'desert']
let boardNums  = [2, 3,3, 4,4, 5,5, 9,9, 10,10, 11,11, 12] //TODO::
let boardSpecialNums = [6,6,8,8]

let offsetVal = imgGridX/2

function setCssVar(name,val) {
  document.documentElement.style.setProperty("--"+name, val);
}

function shuffleArr(arr) {
  let array = arr.slice()
  let currentIndex = array.length, tmp, randomIndex;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    tmp = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = tmp;
  }

  return array;
}

function preventContextMenuOnLongClick() {
  window.oncontextmenu = function(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
}

function getOdds(num) {
  return (6-Math.abs(7-num))
}

function probOf7PerRound(players) {
  let res = 1-(Math.pow(5/6,players))

  return res
}

function* tileIndicesFromOdd(x,y) {
  let isTop = ((y % 2) && !(x % 2)) || (!(y % 2) && (x % 2))        
  if (isTop) {
    yield (new Vector2(Math.floor(x/2)-1, y-1))
    yield (new Vector2(Math.floor(x/2)  , y-1))
    yield (new Vector2(Math.ceil(x/2)-1 , y))
  } else {
    yield (new Vector2(Math.floor(x/2)-1, y))
    yield (new Vector2(Math.floor(x/2),   y))
    yield (new Vector2(Math.ceil(x/2)-1,  y-1))
  }
}

function* adjTileIndicesFromTile(x,y) {
  let isEvenRow = (y % 2 == 0)       

  yield (new Vector2(x-1,y))
  yield (new Vector2(x+1,y))

  if (!isEvenRow) {
    yield (new Vector2(x,y+1))
    yield (new Vector2(x+1,y+1))
    yield (new Vector2(x,y-1))
    yield (new Vector2(x+1,y-1))
  } else {
    yield (new Vector2(x-1,y+1))
    yield (new Vector2(x,y+1))
    yield (new Vector2(x-1,y-1))
    yield (new Vector2(x,y-1))
  }
}

function mergeClasses(c1, c2) {
  c1 = Object.assign({}, c1);
  c2 = Object.assign({}, c2);
  if (!c1) {
    return c2
  }
  if (!c2) {
    return c1
  }

  Object.keys(c2).forEach(function(key,index) {
    if (c1.hasOwnProperty(key)) {
      c1[key] += c2[key]
    } else {
      c1[key] = c2[key]
    }
  });

  return c1
}

function factorial(n) {
  let sum = 1
  for (let i=1; i<n+1; i++) {
    sum *= i
  }
  return sum
}

function bincof(n,k) {
  return factorial(n)/(factorial(k)*factorial(n-k))
}

function brnTrialProb(n, k, p) {
  let q = 1-p
  let prob = bincof(n,k) * Math.pow(p,k) * Math.pow(q, n-k)

  return prob
}

function expectedProbSucc(n, p) {
  /*
  let total = 0

  for (let i=1; i<n+1; i++) {
    total += i*brnTrialProb(n, i, p)
  }
  
  return total

  LOL
  */

  return p * n
}

class CircleNum extends React.Component {
  constructor(props) {
    super(props);

    //minFntSz = 15
    this.minFntSz = 20
    this.maxFntSz = 20
    
    this.selectOpts=[]
    for (let i = 2; i <= 12; i++) {
      if (i != 7) {
        this.selectOpts.push(<option key={i} value={i}>{i}</option>)
      }
    }

    this.state = {
      val: props.val,
      hovered: false,
      focused: false,
    }
  }

  onChange(event) {
    let newNum = event.target.value

    this.setState(
      {val: newNum,
      focused:false});

    this.props.onNumChange(newNum)
  }

  onMouseEnter() {
    this.setState({hovered:true})
  }

  onMouseLeave() {
    this.setState({hovered:false})
  }

  
  onFocusEnter() {
    this.setState({focused:true})
  }

  onFocusLeave() {
    this.setState({focused:false})
  }

  render() {
    let odds = getOdds(this.state.val)

    //let fntSz;
    let opacity = 1
    let clr = "black";
    if (this.state.hovered || this.state.focused) {
      //fntSz = this.maxFntSz;
      opacity = 1
    } else {
      //fntSz = this.minFntSz + (odds-1)/4 * (this.maxFntSz-this.minFntSz)
      opacity = 0.3 + (odds-1)/4 * (0.5)
      if (odds == 5) {
        clr = "red"
      }
    }

    let style = {
      /*fontSize: fntSz+"px",*/
      opacity: opacity,
      color: clr
    }

    return (
      <div className="circle">
        <select className="tileNumSelect" value={this.state.val}
          onChange={(event)=>this.onChange(event)}
          onMouseEnter={()=>{this.onMouseEnter()}}
          onMouseLeave={()=>{this.onMouseLeave()}}
          onFocus={()=>{this.onFocusEnter()}}
          onBlur={()=>{this.onFocusLeave()}}
          style={style}
        >
          { this.selectOpts }
        </select>
      </div>
    )
  }
}

class TileAddBtn extends React.Component {

  onClick() {
    console.log("clicked");
    this.props.onBtnClick(this.props.resourceType);
  }

  render() {
    let imgPath = `/tilepics/${this.props.resourceType}.png`

    return(
      <div className="tileBtn">
        <div className="tileBtnContainer"
        onClick={()=>{this.onClick()}}>
          <img src={imgPath} className="tileImgBtn" draggable="false">
          </img>
          <div className="btnPlusSign">
            +
          </div>
        </div>
      </div>
    )
  }
}

let defZVal = 100
let currZVal = defZVal

class Tile extends React.Component {

  posX = 0
  posY = 0

  isOutOfBounds = false

  constructor(props) {
    super(props);

    let offset = false
    if (props.offset == "t") {
      offset = true
    }

    this.prevX = props.startX
    this.prevY = props.startY

    this.state = {
      toOffset: offset,
      isDraging: false,
      zVal: defZVal,
      posX: this.posX,
      posY: this.posY
    }
  }

  componentDidMount() {
    this.snapToGridPosition()
  }

  onDragStart(event, data) {
    console.log(`Start x: ${data.x}, y: ${data.y}`);

    this.mouseX = data.x
    this.mouseY = data.y

    /*
    let gridIdxX = Math.round(data.x/imgGridX)
    let gridIdxY = Math.round(data.y/imgGridY)

    this.prevX = gridIdxX
    this.prevY = gridIdxY
    */

    //this.setState({isDraging: true});
    currZVal++
    this.setState({
      zVal:currZVal,
      isDraging: true
    })
  }
  
  getGridCoords(gridX,gridY) {
    return {
      x: gridX * imgGridX, 
      y: gridY * imgGridY
    }
  }

  onDrag(event, data) {
      //console.log(`x: ${data.x}, y: ${data.y}`);
      
      let mouseDX = data.x - this.mouseX
      let mouseDY = data.y - this.mouseY

      //console.log(`DELTA: ${mouseDX}, ${mouseDY}`)

      this.posX += mouseDX
      this.posY += mouseDY

      this.setState({
        posX: this.posX,
        posY: this.posY
      })

      this.mouseX = data.x
      this.mouseY = data.y



      if (this.posX < -imgGridX || this.posY < -imgGridY) {
        this.isOutOfBounds = true
      } else {
        this.isOutOfBounds = false
      }

      let gridIdxY = Math.round(this.posY/imgGridY)
      if (gridIdxY < 0) {
        gridIdxY = 0
      }
      let offsetX = 0
      if (this.isOffsetRow(gridIdxY)) {
        offsetX = 0.5
      }
      
      let gridIdxX = Math.round((this.posX - offsetX*imgGridX)/imgGridX)

      if (gridIdxX < 0) {
        gridIdxX = 0
      }

//      console.log(`idx: ${gridIdxX},${gridIdxY}`)

      if (gridIdxX != this.prevX || gridIdxY != this.prevY) {
        console.log(`GRIDDDD: ${gridIdxX}, ${gridIdxY}`)
        console.log(`PREV: ${this.prevX}, ${this.prevY}`)
        this.props.onMove(gridIdxX, gridIdxY, this.prevX, this.prevY, this.props.resourceType, this.props.num)
        this.prevX = gridIdxX
        this.prevY = gridIdxY
        console.log(`UPDATE PREV: ${this.prevX}, ${this.prevY}`)
      }
      //this.setState({toOffset: (gridIdxY % 2 != 0)});

      //console.log(`offset: `)
  }

  onDragStop(event, data) {
    console.log(`End x: ${data.x}, y: ${data.y}`);
    //this.setState({isDraging: false});

    /*
    let gridIdxX = Math.round(data.x/imgGridX)
    let gridIdxY = Math.round(data.y/imgGridY)

    this.prevX = gridIdxX
    this.prevY = gridIdxY
    */

    if (this.isOutOfBounds) {
      this.props.onDelete(this.prevX, this.prevY)
    } else {
      this.snapToGridPosition()

      this.isOutOfBounds = false
  
      this.setState({
        isDraging: false
      })
    }

    //this.props.onMove(gridIdxX, gridIdxY, this.prevX, this.prevY, this.props.resourceType, this.props.num)
  }

  onNumChange(newNum) {
    this.props.onNumChange(this.prevX, this.prevY, newNum)
  }

  isOffsetRow(gridY) {
    return (gridY % 2 != 0)
  }

  getSnappedPos() {
    let offsetX = 0
    
    if (this.isOffsetRow(this.prevY)) {
      offsetX = imgGridX/2
    }

    let x = this.prevX * imgGridX + offsetX
    let y = this.prevY * imgGridY

    return {x,y}
  }

  snapToGridPosition() {
    let pos = this.getSnappedPos()

    this.posX = pos.x
    this.posY = pos.y

    this.setState({
      posX: this.posX,
      posY: this.posY
    })
  }

  render() {
    let imgPath = `/tilepics/${this.props.resourceType}.png`
    let shadowImgPath = '/tilepics/tile_shadow.png'
    let crossImgPath = '/tilepics/cross.png'

    //console.log(this.state.isDraging)

    //let zVal = 1
    //if (this.state.isDraging) {
    //  zVal = 100;
    //}

    //console.log(`POSSSSS: ${this.state.posX}, ${this.state.posY}`)

    /*
    let scl = 1
    if (!this.notFirstRun) {
      scl = 0
      this.notFirstRun = true
    }
    */

    let style = {
      //transform: `translate(${offset+totalOffsetX}px, ${totalOffsetY}px)`,
      zIndex: this.state.zVal,
      //transform: `scale(${scl})`
    }

    let offsetStyle = {
      transform: `translate(${totalOffsetX+this.posX}px, ${totalOffsetY + this.posY}px)`
    }

    let imgClass = "tileImg"
    let tileOffsetClass = "tileOffsetContainer"

    let shadowImgClass = imgClass + " shadowImg"
    let shadowPos = this.getSnappedPos()
    let shadowImgStyle = {
      transform: `translate(${totalOffsetX + shadowPos.x}px, ${totalOffsetY + shadowPos.y}px) scale(1.2)`
    }

    let shadowJsx = null

    if (this.state.isDraging) {
      shadowJsx = <img src={shadowImgPath} className={shadowImgClass} draggable="false" style={shadowImgStyle}/>

      imgClass += " shadowedImg"
      tileOffsetClass += " tileOffsetContainerDrag"
    }
    
    let crossStyle = {
      //transform: `translate(${totalOffsetX+this.posX}px, ${totalOffsetY + this.posY}px)`,
      zIndex: this.state.zVal+1
    }

    let crossJsx = null
    if (this.isOutOfBounds) {
      crossJsx = <img src={crossImgPath} className="crossImg" draggable="false" style={crossStyle}/>
    }

    let circle;
    if (this.props.resourceType != "desert") {
      circle = <CircleNum 
        val={this.props.num} 
        onNumChange = {(newNum) => this.onNumChange(newNum)}
      />
    }


    return (
      <div className="tileContainer" style={style}>
        {shadowJsx}
        <DraggableCore
          //defaultPosition={{x: this.prevX*imgGridX, y: this.prevY*imgGridY}}
          //grid={[imgGridX, imgGridY]}
          onStart={(event, data)=>{this.onDragStart(event, data)}}
          onDrag={(event, data)=>{this.onDrag(event, data)}}
          onStop={(event, data)=>{this.onDragStop(event, data)}}
          bounds={{top: 0, left: 0}}
          cancel=".tileNumSelect"
          >
              <div className={tileOffsetClass} style={offsetStyle}>
                <div className="tileScaleContainer">
                  {crossJsx}
                  <img src={imgPath} className={imgClass} draggable="false"/>
                  {circle}
                </div>
              </div>
        </DraggableCore>
      </div>
    )
  }
}

class OddTypeSwitch extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = { 
      checked: false 
    };
  }
 
  onChange(checked) {
    this.setState({ checked });
    this.props.onChange(checked)
  }
 
  render() {
    return (
      <div className="oddsSwitchContainer">
        <div className="oddsSwitchText">
          Calculate Rarity
        </div>
        <div className="oddsSwitch">
          <UISwitch 
            onChange={(checked)=>{this.onChange(checked)}} 
            checked={this.state.checked} 
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={25}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="react-switch"
            id="material-switch"
          />
        </div>
      </div>
    );
  }
}

class OddCircle extends React.Component {
  constructor(props) {
    super(props)

  }

  onClick() {
    this.props.onClick(this.props.x, this.props.y)
    /*
    this.setState({
      selected: !this.state.selected
    })
    */
  }

  render() {
    let x = this.props.x
    let y = this.props.y

    /*
    let clr = '#e6e6e666'
    if (this.props.selected == 1) {
      clr = '#2268ffa8'
      //console.log(`selected!! ${x},${y}`)
    } else if (this.props.selected == 2) {
      clr = '#55aaffa8'
    }
    */

    let cname = "oddValCircle"
    if (this.props.selected == 1) {
      cname += " oddValCircleSel1"
    } else if (this.props.selected == 2) {
      cname += " oddValCircleSel2"
    }
  
    let topPos = y*imgGridY
    let isTop = ((y % 2) && !(x % 2)) || (!(y % 2) && (x % 2))
    if (!isTop) {
      topPos = topPos + imgGridY*0.25
    }

    let circleStyle = {
      top: (titleBarSize + totalOffsetY + topPos) + "px",
      left: (totalOffsetX + x*imgGridX/2)+"px",
      //backgroundColor: clr
    }

    
    let textStyle = {
      opacity: 0.3 + (this.props.odd/this.props.maxVal)*0.7
    }

    return (
      <div className={cname} 
           style={circleStyle}
           onClick={()=>{this.onClick()}}>
        <div className="oddVal" style={textStyle}>
          {this.props.odd}
        </div>
      </div>
    )
  }
}

class NumSelector extends React.Component {

  onChange(val) {
    //console.log(`change: ${val}`)
    val = parseFloat(val)
    if (!isNaN(val)) {
      if (val > this.props.max) {
        val = this.props.max
      }
      if (val < this.props.min) {
        val = this.props.min
      }
      this.props.onChange(val);
    }
  }

  render() {
    return(
      <input 
        type="number" 
        className="numSelector" 
        min={this.props.min}
        max={this.props.max}
        value={this.props.val}
        onChange={(event)=>{this.onChange(event.target.value)}}
      />
    )
  }

}

let currTileId = 0
class TileVal {
  resourceType;
  num;
  x;
  y;

  constructor(type, num, x, y) {
    this.resourceType = type;
    this.num = num;
    this.x = x;
    this.y = y;
    this.id = currTileId++;
  }

  zeroPad(num, places) {
    return String(num).padStart(places, '0')
  }

  makeString() {
    let res = ""
    let TilePosVal = this.y * tileGridSz + this.x
    res += this.zeroPad(TilePosVal, 3); //3 digits
    let numVal = this.num
    if (numVal >= 7) {
      numVal -= 1;
    }
    numVal -= 2
    if (numVal < 0) {
      numVal = 0
    }
    res += numVal // 1 digit
    res += resources.indexOf(this.resourceType) //1 digit
    
    return res
  }

  setFromString(str) {
    if (str.length != 5) return false;
    console.log(`parsing str ${str}`);
    let tilePosStr = str.substring(0,3)
    console.log(tilePosStr);
    this.y = Math.floor(parseInt(tilePosStr) / tileGridSz)
    this.x = parseInt(tilePosStr) % tileGridSz

    this.num = str[3]
    console.log(`num: ${this.num}`);
    this.num = parseInt(this.num) + 2
    if (this.num >= 7) {
      this.num += 1
    }
    console.log(`num2: ${this.num}`);

    console.log(str);
    let typeIdx = str[4]
    console.log(`typeIdx: ${typeIdx}`);
    this.resourceType = resources[typeIdx]
    
    console.log(this.type);

    return true;
  }
}


//even rows: x+1,y , x-1,y , x,y-1,  x-1,y-1 , x,y+1 , x-1,y+1
//odd rows: x+1,y , x-1,y , x,y-1,  x+1,y-1 , x,y+1 , x+1,y+1

function gen2dArrOfStacks(sz) {
  let arr = new Array(sz)
  for (let i=0; i<sz; i++) {
    arr[i] = new Array(sz)
    for (let j=0; j<sz; j++) {
      arr[i][j] = []
    }
  }

  return arr
}

class Vector2 {
  constructor(x,y) {
    this.x = x
    this.y = y
  }

  equalsVec(otherVec) {
    if (otherVec == null) {
      return false
    }
    return(this.equals(otherVec.x, otherVec.y))
  }

  equals(otherX, otherY) {
    //console.log(`${this.x},${this.y} = ${otherX}, ${otherY}`)
    if (this.x == otherX && this.y == otherY) {
      return true
    } else {
      return false
    }
  }

}

const tileGridSz = 15

class Board extends React.Component {
  tiles = []

  oddsGridSz = tileGridSz*2 + 1

  accountForRarity = false

  selectedOdd1 = null
  selectedOdd2 = null
  placingFirst = true

  expectedOdds = null

  normalizeOddsTo = 13
  maxOddVal = -1

  NPlayers = 4

  constructor(props) {
    super(props)

    /*
    this.tileGrid = new Array(tileGridSz)
    for (let i=0; i<this.tileGrid.length; i++) {
      this.tileGrid[i] = new Array(tileGridSz)
      for (let j=0; j<this.tileGrid[i].length; j++) {
        this.tileGrid[i][j] = []
      }
    }
    */
    //this.tileGrid = Array(tileGridSz).fill(Array(tileGridSz).fill([]));
    //this.oddsGrid = Array(this.oddsGridSz).fill(Array(this.oddsGridSz).fill([]));
    this.tileGrid = gen2dArrOfStacks(tileGridSz)
    this.oddsGrid = gen2dArrOfStacks(this.oddsGridSz)

    //this.genRandomBoard()

    this.urlParams = queryString.parse(window.location.search);

    this.state = {
      tiles: this.tileGrid,
      odds: this.oddsGrid,
      accountForRarity: this.accountForRarity,
      showCpyMsg: false
    }
  }

  componentDidMount() {
    preventContextMenuOnLongClick()

    if (this.urlParams.t) {
      this.genBoardFromString(this.urlParams.t)
    }
  }

  isValidRedPlacement(place, redPlaces) {
    let res = true;
    redPlaces.forEach(redPlace => {
      let adjIndices = adjTileIndicesFromTile(redPlace[0],redPlace[1])
      //console.log(`adj:`, adjIndices);
      let curIdx = adjIndices.next()
      while (!curIdx.done) {
        //console.log(`${curIdx.value.x}, ${curIdx.value.y}`);
        if (curIdx.value.x == place[0] && curIdx.value.y == place[1]) {
          res = false
          break;
        } 
        curIdx = adjIndices.next()
      }
    });

    return res;
  }

  boardToStr() {
    let totStr = ""
    this.tiles.forEach(tile => {
      totStr += tile.makeString()
    })

    //totStr = "1"+totStr
    //console.error(`boardStr:`);
    //console.log(totStr);
    //totStr = parseInt(totStr).toString(36)

    //console.log(totStr);

    console.log(`totstr: ${totStr}`);

    return totStr;
  }

  genBoardFromString(str) {
    this.tiles = []
    this.tileGrid = gen2dArrOfStacks(tileGridSz)
    this.oddsGrid = gen2dArrOfStacks(this.oddsGridSz)

    //str = parseInt(str, 36)
    //str = str.toString().substring(1)
    //console.error(`using string:`)
    //console.log(str);

    while (str && str.length > 0) {
      let currStr = str.substring(0,5);

      let curTile = new TileVal();
      if (curTile.setFromString(currStr)) {
        if (curTile.resourceType == "desert") {
          curTile.num = 1
        }
  
        //console.log(`adding tile:`);
        //console.log(curTile);
  
        this.addTileVal(curTile);
      }

      str = str.substring(5);
    }
  }

  genRandomBoard() {
    this.tiles = []
    this.tileGrid = gen2dArrOfStacks(tileGridSz)
    this.oddsGrid = gen2dArrOfStacks(this.oddsGridSz)

    this.setState( {
      tiles: this.tiles,
      odds: this.oddsGrid,
    })

    let tiles = shuffleArr(boardTiles)
    let nums = shuffleArr(boardNums)
    let redNums = shuffleArr(boardSpecialNums)

    let tileplaces = shuffleArr(tileOrder)

    let redPlaces = []

    console.log(`N: ${redNums.length}`);
    while (redNums.length > 0) {
      let curPlace = tileplaces.pop()

      let res = (this.isValidRedPlacement(curPlace, redPlaces))
      console.log(`res" ${res}`);
      while (!res) {
        console.log(`not valid. searching more`)
        tileplaces.unshift(curPlace)
        curPlace = tileplaces.pop()
        res = (this.isValidRedPlacement(curPlace, redPlaces))
        console.log(`res" ${res}`);
      }
      console.log(`valid: ${curPlace[0]}, ${curPlace[1]}`)

      redPlaces.push(curPlace)

      let type = tiles.pop()
      if (type == 'desert') {
        tiles.unshift(type)
        type = tiles.pop()
      } 
      let num = redNums.pop()
      this.addTile(type, num, curPlace[0], curPlace[1])
    }
    

    console.log(`N: ${nums.length}`);
    while (tileplaces.length > 0) {
      let curPlace = tileplaces.pop()
      let type = tiles.pop()
      let num = -1
      if (type != 'desert') {
        num = nums.pop()
      } 
      this.addTile(type, num, curPlace[0], curPlace[1])
    }
  }


  getBaseUrl() {
    let url = window.location.protocol + "//" + window.location.hostname 
    if (window.location.port) {
      url += ":" + window.location.port
    }

    return url;
  }

  copyBoardLink() {
    let str = this.boardToStr();
    str = this.getBaseUrl() + "/?t=" + str
    this.copyToClip(str);
  }

  copyToClip(str) {
    if (!navigator.clipboard) {
      try {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.onCopySucc();
      } catch (err) {
        this.onCopyFail(err);
      }
    } else {
      navigator.clipboard.writeText(str).then(()=>{
        this.onCopySucc();
      }, function(err) {
        this.onCopyFail(err)
      })
    }
  }

  onCopySucc() {
    console.log(`Copied succ`);
    this.setState({
      showCpyMsg: true
    })
  }
  onCopyFail(err) {
    console.log(`Copy err: ${err}`);
  }
  onCopyMsgAnimationEnd() {
    this.setState({
      showCpyMsg: false
    })
  }
  
  onOddCircleClick(x, y) {
    let newVec =  new Vector2(x,y)

    if (newVec.equalsVec(this.selectedOdd1)) {
      this.selectedOdd1 = null
    } else if (newVec.equalsVec(this.selectedOdd2)) {
      this.selectedOdd2 = null
    } else if (this.selectedOdd1 == null) {
      this.selectedOdd1 = newVec
      this.placingFirst = false
    } else if (this.selectedOdd2 == null) {
      this.selectedOdd2 = newVec
      this.placingFirst = true
    } else {
      if (this.placingFirst) {
        this.selectedOdd1 = newVec
      } else {
        this.selectedOdd2 = newVec
      }
      this.placingFirst = !this.placingFirst
    }

    this.calcExpectedOdds()

    this.forceUpdate()
  }

  getTileAt(x,y) {
    if (x >= 0 && x < this.tileGrid.length && y >= 0 && y < this.tileGrid.length) {
      let tileStack = this.tileGrid[x][y]
      if (tileStack.length > 0) {
        return (tileStack[tileStack.length-1])
      }
    }
    return null
  }

  getTileOddsAt(x,y, accountForRarity=false) {
    let tile = this.getTileAt(x,y)
    if (tile) {
      let odds = getOdds(tile.num)
      if (accountForRarity && odds > 0) {
        let type = tile.resourceType
        odds = odds / (totalResources[type] / totalResourcesAll) * totalResroucesNeeded[type]
      } else {
        //console.log(this.state.NPlayers)

        //console.log("odds")
        //odds = odds / 36 * this.NPlayers * 10
        //console.log(odds)
        //odds = Math.round(odds)
        //console.log(odds)
      }
      //console.log(`found tile at ${x},${y} odds ${odds}`)
      return odds
    }

    return 0
  }

   calcResourcePercents() {
    for (let key in totalResources) {
      totalResources[key] = 0
    }
    
    for (let x=0; x<tileGridSz; x++) {
      for (let y=0; y<tileGridSz; y++) {
        let tileStack = this.tileGrid[x][y]
        if (tileStack.length > 0) {
          let item = tileStack[tileStack.length-1]
          if (item.num > 1) {
            totalResources[item.resourceType] += getOdds(item.num)
          }
        }
      }
    }

    totalResourcesAll = 0
    for (let key in totalResources) {
      totalResourcesAll += totalResources[key]
    }

    console.log(totalResourcesAll)

    console.log(totalResources)
   }

  calcOdds() {
    let accountForRarity=this.accountForRarity

    //if (accountForRarity) {
      this.calcResourcePercents()
    //}

    let maxVal = -1

    for (let x=0; x<this.oddsGridSz; x++) {
      for (let y=0; y<this.oddsGridSz; y++) {
        let sum = 0

        let adjIndices = tileIndicesFromOdd(x,y)
        let curIdx = adjIndices.next()
        while (!curIdx.done) {
          sum += this.getTileOddsAt(curIdx.value.x, curIdx.value.y, accountForRarity)
          curIdx = adjIndices.next()
        }

        sum = Math.round(sum)

        this.oddsGrid[x][y] = sum

        if (sum > maxVal) {
          maxVal = sum
        }
      }
    }

    this.maxOddVal = maxVal

    /*
    let normVal = this.getNormalizeOddsVal()
    let cof = 1
    if (this.accountForRarity) {
      if (normVal > 0) {
        cof = normVal / maxVal
      }
    } else {
      cof = 1 / 36 * this.NPlayers
    }*/


    if (this.accountForRarity) {
      for (let x=0; x<this.oddsGridSz; x++) {
        for (let y=0; y<this.oddsGridSz; y++) {
          let curVal = this.oddsGrid[x][y]
          if (curVal > 0) {
            let newVal = Math.round(this.oddsGrid[x][y] * this.normalizeOddsTo / maxVal)
            if (newVal < 1) {
              newVal = 1
            }
            this.oddsGrid[x][y] = newVal
          }
        }
      }
    }

    

    this.calcExpectedOdds()
  }

  getExpectedFromOdd(odd) {
    return (odd / 36 * this.NPlayers)
  }

  //calc expected odds of placements
  calcExpectedOdds() {
    let exp1 = null
    let exp2 = null

    if (this.selectedOdd1) {
      exp1 = this.calcExpectedOdd(this.selectedOdd1.x, this.selectedOdd1.y)    
    }
    if (this.selectedOdd2) {
      exp2 = this.calcExpectedOdd(this.selectedOdd2.x, this.selectedOdd2.y)    
    }

    exp1 = mergeClasses(exp1, exp2)

    this.expectedOdds = exp1
    
    //console.log(this.expectedOdds)
  }

  calcExpectedOdd(oddX,oddY) {
    let res = {}

    let adjIndices = tileIndicesFromOdd(oddX,oddY)
    let curIdx = adjIndices.next()
    while (!curIdx.done) {
      let tile = this.getTileAt(curIdx.value.x, curIdx.value.y)
      if (tile) {
        if (res.hasOwnProperty(tile.resourceType)) {
          res[tile.resourceType] += getOdds(tile.num)
        } else {
          res[tile.resourceType] = getOdds(tile.num)
        }
      }
      curIdx = adjIndices.next()
    }

    return res
  }

  calcRoundsToBuild(initialRes, expectedRes, neededRes) {
    let maxRoundsNeeded = -1
    for (let key in neededRes) {
      let roundsNeeded = Infinity
      let amountNeeded = neededRes[key]
      if (initialRes.hasOwnProperty(key)) {
        amountNeeded -= initialRes[key]
      }
      if (amountNeeded <= 0) {
        roundsNeeded = 0
      } else {
        if (expectedRes.hasOwnProperty(key)) {
          let expected = this.getExpectedFromOdd(expectedRes[key])
          console.log(`expe ${expected}`)
          roundsNeeded = Math.ceil(amountNeeded / expected)
        }
      }

      console.log(`${key} needs ${roundsNeeded} rounds. ${amountNeeded} amount`)

      if (roundsNeeded > maxRoundsNeeded) {
        maxRoundsNeeded = roundsNeeded
      }
    }

    return maxRoundsNeeded
  }


  getInitialResourcesFromIntersection(x,y) {
    let res = {}
    let adjIndices = tileIndicesFromOdd(x,y)
    let curIdx = adjIndices.next()
    while (!curIdx.done) {
      let tile = this.getTileAt(curIdx.value.x, curIdx.value.y)
      if (tile) {
        if (res.hasOwnProperty(tile.resourceType)) {
          res[tile.resourceType] += 1
        } else {
          res[tile.resourceType] = 1
        }
      }
      curIdx = adjIndices.next()
    }

    return res
  }

  calcRoundsToCity() {
    if (this.expectedOdds) {
      let initialRes = {}
      if (this.selectedOdd2) {
        initialRes = this.getInitialResourcesFromIntersection(this.selectedOdd2.x, this.selectedOdd2.y)
      }
      return this.calcRoundsToBuild(initialRes, this.expectedOdds, cityResourcesNeeded)
    }

    return null
  }

  calcRoundsToFirstSettlement() {
    let resNeeded = mergeClasses(settlementResourcesNeeded, roadResourcesNeeded)

    if (this.selectedOdd1 && this.selectedOdd2) {
      let initialRes = this.getInitialResourcesFromIntersection(this.selectedOdd2.x, this.selectedOdd2.y)
      return this.calcRoundsToBuild(initialRes, this.expectedOdds, resNeeded)
    }

    return null
  }

  getNormalizeOddsVal() {
    if (this.accountForRarity) {
      return this.normalizeOddsTo
    } else {
      return -1
    }
  }

  getMaxOddVal() {
    if (this.accountForRarity) {
      return this.normalizeOddsTo
    } else {
      return this.maxOddVal
    }
  }

  getOddsJsx() {
    let jsx = []

    let max=this.getMaxOddVal()

    for (let x=0; x<this.oddsGridSz; x++) {
      for (let y=0; y<this.oddsGridSz; y++) {
        if (this.oddsGrid[x][y] > 0) {


          let odd = this.oddsGrid[x][y]

          let selected = 0
          
          if (this.selectedOdd1 && this.selectedOdd1.equals(x,y)) {
            selected = 1
          } else if (this.selectedOdd2 && this.selectedOdd2.equals(x,y)) {
            selected = 2
          }

          jsx.push(
            <OddCircle
              x={x}
              y={y}
              odd={odd}
              onClick={(x,y)=>{this.onOddCircleClick(x,y)}}
              selected={selected}
              maxVal={max}
            />
          )
        }
      }
    }
    return jsx
  }

  getTilesJsx() {
    let jsx = []
/*
    for (let x=0; x<tileGridSz; x++) {
      for (let y=0; y<tileGridSz; y++) {
        let tileStack = this.tileGrid[x][y]
        if (tileStack.length > 0) {
          let item = tileStack[tileStack.length-1]
          console.log(`drawing tile ${item.resourceType} ${item.num} at ${x},${y}`)
          jsx.push(
            <Tile 
            resourceType={item.resourceType} 
            num={item.num}
            onMove = {(gridIdxX, gridIdxY, prevX, prevY, type, num)=>{this.onMove(gridIdxX, gridIdxY, prevX, prevY, type, num)}}
            onNumChange = {(x, y, newNum) => this.onTileNumChange(x, y, newNum)}
            />
          )
        }
      }
    }
    */

    this.tiles.forEach(item => {
      jsx.push(
        <Tile 
        resourceType={item.resourceType} 
        startX={item.x}
        startY={item.y}
        num={item.num}
        onMove = {(x, y, prevX, prevY, type, num)=>{this.onMove(x, y, prevX, prevY, type, num)}}
        onDelete={(x,y)=>{this.onTileDelete(x,y)}}
        onNumChange = {(x, y, newNum) => this.onTileNumChange(x, y, newNum)}
        key={`TileN${item.id}`}
        />
      )
    });

    let style = {
      width: (totalOffsetX+5*imgGridX+50)+"px",
      height: (totalOffsetY+5*imgGridY+50)+"px"
    }

    return (
      <div className="tilesContainer" style={style}>
        {jsx}
      </div>
    )
  }

  getBtnsJsx() {
    let jsx = []
    resources.forEach(res => {
      jsx.push(
        <TileAddBtn onBtnClick={(type)=>{this.onTileBtnClick(type)}} resourceType={res}/>
      )
    });
    return (
      <div className="btnsContainer">
        Add Tile:
        {jsx}
      </div>
    )
  }

  getResChartJsx() {
    let data = []
    for (let key in totalResources) {
      if (totalResources[key] > 0) {
        data.push(
          {
            title: key,
            value: Math.round(totalResources[key] / totalResourcesAll * 100),
            color: resClrs[key]
          }
        )
      }
    }

    if(data.length > 0) {
      return (
        <div className="resChartContainer">
          Resource Distribution:
          <PieChart
           className="resChart"
           data={data}
           style={{
            height: '150px'
           }}
           label={(props)=>{return `${Math.round(props.data[props.dataIndex].percentage)}%`}}
           labelPosition={50}
           labelStyle={{
            fill: 'black',
            fontSize: '12px',
            fontWeight: '1'
          }}
          />
        </div>
      )
    }
  }

  getExpectedOddsJsx() {
    let jsx = []
    let odds = this.expectedOdds
    jsx.push(<div className="expectedOddTitle">Expected Per Round</div>)

    if (this.expectedOdds) {
      resources.forEach(res => {
        if (odds[res] > 0) {
          let imgPath = `/tilepics/${res}_icon.png`
          jsx.push(
            <div className="expectedOddLine">
              <img src={imgPath} className="expectedResIcon" draggable="false"/> - {parseFloat(this.getExpectedFromOdd(odds[res])).toFixed(2)}
            </div>
          )
        }
      });

      /*
      Object.keys(this.expectedOdds).forEach(function(key,index) {

      })
      */
    }

    jsx.push(<div className="svnOdds">Robber - {parseFloat(probOf7PerRound(this.NPlayers)).toFixed(2)}</div>)

    return jsx
  }

  getBuildInfoJsx() {
    let jsx = []

    let roundsToCity = this.calcRoundsToCity()
    let roundsToSet = this.calcRoundsToFirstSettlement()

    console.log(roundsToCity)

    if (roundsToCity && roundsToCity < Infinity) {
      jsx.push(
        <div className="cityBuildInfo">
          {roundsToCity} rounds to first city
        </div>
      )
    }

    if (roundsToSet && roundsToSet < Infinity) {
      jsx.push(
        <div className="cityBuildInfo">
          {roundsToSet} rounds to first settlement
        </div>
      )
    }

    return jsx
  }

  getDataCell(jsx) {
    console.log(jsx)
    if (jsx && (!Array.isArray(jsx) || jsx.length > 0)) {
      console.log("not empty")
      return (
        <div className="dataContainerCell">
          {jsx}
        </div>
      )
    } else {
      return null
    }
  }

  getGenBoardBtnsJsx() {
    let diceImgPath = './tilepics/dice.png'
    let shareImgPath = './tilepics/share.png'

    let cpyMsg = null
    if (this.state.showCpyMsg) {
      cpyMsg =       
        <div className="copiedSuccMsg"
        onAnimationEnd={()=>this.onCopyMsgAnimationEnd()}>
          Copied to clipboard!
        </div>

    }

    return (
    <div className = "emptyBoardGenBtnsContainer">
      Generate Board:
      <div className = "rndBoardBtn tileBtnContainer" onClick={()=>this.genRandomBoard()}>
        <img className="rndBoardBtnImg" src={diceImgPath}></img>
      </div>

      
      <img className="shareImg" src={shareImgPath} onClick={()=>this.copyBoardLink()}></img>
      {cpyMsg}
    </div>
    )
  }

  getDataJsx() {
    let resChart = this.getDataCell(this.getResChartJsx())
    let oddTypeBtns = this.getOddTypeBtns()
    let expectedOddsInfo = this.getDataCell(this.getExpectedOddsJsx())
    let buildInfo = this.getDataCell(this.getBuildInfoJsx())
    let genBtns = this.getDataCell(this.getGenBoardBtnsJsx())

    return (
      <div className="dataContainer">
        <div className="dataContainerCell">
          <div className="nPlayersFieldContainer">
            Players:
            <NumSelector
              min="3"
              max="6"
              val={this.NPlayers}
              onChange={(val)=>{this.onNPlayersChange(val)}}
            />
          </div>
          {oddTypeBtns}
        </div>
        {resChart}
        {expectedOddsInfo}
        {buildInfo}
        {genBtns}
      </div>
    )
  }

  getemptyBoardNoteJsx() {
    let jsx = []
    let arrowImgPath = './tilepics/arrow1.png'
    let arrow2ImgPath = './tilepics/arrow2.png'

    if (this.tiles.length == 0) {
      jsx.push(
          <div className="emptyBoardNote">
            <div className="emptyBoardTitle">
              Your board is empty
            </div>
            <div className="emptyBoardNote1">
              Add some tiles by clicking the buttons over here
              <img src={arrowImgPath} className="emptyBoardArrow"/>
            </div>
            <div className="emptyBoardNote2">
              Or click here to generate a random board
              <img src={arrow2ImgPath} className="emptyBoardArrow2"/>
            </div>
          </div>
      )
    }

    return jsx
  }

  onOddsSwitchChange(checked) {
    this.accountForRarity = checked
    this.calcOdds()
    this.setState({accountForRarity: checked})
  }

  getOddTypeBtns() {
    return (
      <OddTypeSwitch
      onChange={(checked)=> {this.onOddsSwitchChange(checked)}}
      />
    )
  }

  addTileVal(tile) {
    this.tiles.push(tile)

    this.tileGrid[tile.x][tile.y].push(tile)
    this.calcOdds()

    this.setState({
      tiles: this.tiles,
      odds: this.oddsGrid
    })

    //console.log(this.tileGrid)
  }

  addTile(type, num, x=0, y=0) {
    if (type == "desert") {
      num = 1
    }

    if (num == -1) {
      num = 2 + Math.floor(Math.random()*10)
      if (num >= 7) {
        num += 1
      }
    }

    let tile = new TileVal(type, num, x, y);

    this.addTileVal(tile)
  }

  onTileBtnClick(type) {
      let x=0
      let y=0

      for (let i=0; i<tileOrder.length; i++) {
        let el = tileOrder[i]
        if (this.tileGrid[el[0]][el[1]].length == 0) {
          x = el[0]
          y = el[1]
          break
        }
      }

    this.addTile(type, -1, x,y);
  }

  removeTileFromList(tile) {
    let foundIdx = -1
    let id = tile.id
    for (let i=0; i<this.tiles.length; i++) {
      if (this.tiles[i].id == id) {
        foundIdx = i
        break
      }
    }

    if (foundIdx > -1) {
      this.tiles.splice(foundIdx,1)
    }
  }

  onTileDelete(x, y) {
    console.log(`Deleting TILE!!! ${x}, ${y}`);
    let tile = this.tileGrid[x][y].pop()

    this.removeTileFromList(tile)
    //if (idx !== -1) this.tiles.splice(idx, 1);

    this.calcOdds()

    this.setState({
      tiles: this.tiles
    })
  }

  onMove(x, y, prevX, prevY, type, num) {
    let popd = this.tileGrid[prevX][prevY].pop()

    //let tile = new TileVal(popd.resourceType, popd.num);
    let tile = popd

    tile.x = x
    tile.y = y

    //if (popd) {
    //  if (popd.resourceType != tile.resourceType || popd.num != tile.num) {
    //    console.error(`NOT THE SAME!!! popd ${prevX},${prevY} ${popd.resourceType},${popd.num}. got ${tile.resourceType}, ${tile.num} at ${x},${y}`)
    //  }
    //} else {
    //  console.log("popped empty")
    //}

    //this.calcOddsDelay(0)

    this.tileGrid[x][y].push(tile)

    //for transition. TODO::can remove
    this.calcOddsDelay(0)

    //console.log(this.tileGrid)
  }

  async calcOddsDelay(s) {
    if (s > 0) {
      await new Promise(r => setTimeout(r, s*1000));
    }
    
    this.calcOdds()
    this.setState({odds: this.oddsGrid})
  }

  onTileNumChange(x, y, newNum) {
    //console.log(`change: ${x},${y}, ${newNum}`)
    let tileStack = this.tileGrid[x][y]
    if (tileStack.length > 0) {
      tileStack[tileStack.length-1].num = newNum;

      this.calcOdds()

      this.setState({
        tiles: this.tileGrid,
        odds: this.oddsGrid
      })
    }
  }

  onNPlayersChange(newNPlayers) {
    //console.log(`newP: ${newNPlayers}`)
    this.NPlayers = newNPlayers

    this.calcOdds()

    this.forceUpdate()
  }

  render() {
    let odds = this.getOddsJsx()
    let tiles = this.getTilesJsx()
    let btns = this.getBtnsJsx()
    let dataCont = this.getDataJsx()
    let emptyBoardNote = this.getemptyBoardNoteJsx()

    let r = this.calcRoundsToCity()
    let s = this.calcRoundsToFirstSettlement()
    let svnOdd = probOf7PerRound(this.NPlayers)
    //console.log(`city: ${r}`)
    //console.log(`set: ${s}`)
    //console.log(`7: ${svnOdd}`)

    return(
      <div className="main">
        <div className="titleBar">
          <div className="mainTitle">
            Catan Board Analyzer
          </div>
        </div>

        <div className="board">
          {tiles}
          {odds}

          <div className="mainContainer">
            {btns}
            <div className="boardPlaceHolder">
              {emptyBoardNote}
            </div>
            {dataCont}
          </div>
        </div>

        <div className="footer">
          Created by Shir Borer - <a href="mailto:shirborer@gmail.com"> Contact. </a> 
        </div>
      </div>

    )
  }

}

function App() {
  setCssVar("tileSize", imgSize+"px");
  setCssVar("circleSize", circleSize+"px");
  setCssVar("titleBarSize", titleBarSize+"px");

  return (
    <div className="App">
      <Helmet 
        title="Catan Board Analyzer"
        /*
        meta={[
          {name: 'viewport', content: `width=${totalOffsetX+5*imgGridX+50}, initial-scale=1`}
        ]}
        */
      />

      <BrowserRouter>
        <Switch>
          <Route path='/' component={Board} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
